import { formatAmountDisplay } from '../../../services/utils/utils'

/**
 * Display a ledger quantity without changing its value.
 * The API sends a fixed scale (trailing zeros). Group thousands and drop those zeros.
 */
export function formatReportQuantity(value: unknown): string {
  if (value === undefined || value === null || value === '') return '—'

  const raw = String(value).trim()
  if (!raw) return '—'

  const amount = Number(raw)
  if (!Number.isFinite(amount)) return raw

  return amount.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  })
}

/** Display a ledger money amount with the shared Busman decimal format. */
export function formatReportValue(value: unknown): string {
  return formatAmountDisplay(value)
}
